<template>
  <div class="change-box-container">
    <div class="change-box-header">
      <div class="header-left">
        <img src="@images/logo.png"
             alt="森普瑞">
        <div class="supplierTitle">供应商查询系统</div>
      </div>

      <div class="header-right">
        <a href="http://www.spr-atm.com"
           target="__blank"
           class="gobeyond">
          Gobeyond
        </a>
        <router-link to="/home"
                     replace
                     class="exit">
          退出
        </router-link>
      </div>
    </div>
    <el-card>
      <div class="card-header">
        账号安全
      </div>
      <div class="card-content">
        <slot name="content"></slot>
      </div>
    </el-card>
    <div class="change-box-footer">
      <p>粤公网安备 44030502004606号 粤ICP备14076614号</p>
      <p>Copyright &copy; 深圳市森普瑞科技有限公司 版权所有</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },
  created () { },
  methods: {},
};
</script>
<style lang="less" scoped>
.change-box-container {
  width: 750px;
  font-family: 'Source Han Sans CN';
  cursor: default;
}
.change-box-header {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-left{
    width: 250px;
    display: flex;
    flex-direction: row;
    align-items: center;
    img {
     height: 55px;
    }
  .supplierTitle{
      margin-left: 10px;
      font-size: 16px;
      font-weight: bold;
      color: #027cff;
    }
  }
  
  .header-right {
    display: flex;
    .gobeyond {
      padding-right: 20px;
      border-right: 1px solid #2f343c;
      font-family: 'Segoe UI';
    }
    .exit {
      padding-left: 20px;
      font-family: 'Source Han Sans CN';
      color: #027cff;
    }
  }
}
.el-card {
  /deep/ .el-card__body {
    padding: 0;
  }
  .card-header {
    width: 100%;
    height: 60px;
    background-color: #027cff;
    color: #ffffff;
    font-size: 20px;
    line-height: 60px;
    text-align: center;
  }
  .card-content {
    padding: 30px 0 40px;
    background-color: #ffffff;
  }
}
.change-box-footer {
  margin-top: 40px;
  p {
    text-align: center;
    color: #b7bbc8;
    padding: 5px 0;
  }
}
</style>